import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-navy-800 px-5 py-16 sm:py-20" data-id="element-17" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-6xl" data-id="element-18" data-mp="pj6cm4pkakr0">
        <div className="text-center" data-id="element-19" data-mp="avcvgfktva6b">
          <h2 className="font-display text-3xl font-black text-white sm:text-4xl" data-id="element-20" data-mp="aua8ujujftw7">
            🎁 You Also Get <span className="text-gold" data-id="element-21" data-mp="fsv7ieu565ij">5 Strategic Bonuses</span>
          </h2>
          <p className="mt-3 text-sm uppercase tracking-[0.18em] text-white/50" data-id="element-22" data-mp="1u598vvl5zsl">
            Included at no extra cost
          </p>
          <p className="mt-5 inline-flex rounded-full border border-gold/40 bg-gold/10 px-4 py-2 text-sm font-bold text-gold" data-id="element-23" data-mp="5xbeq1avjmy0">
            Real value: $274 — today included FREE
          </p>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-24" data-mp="3t0y99wen7svj">
          {bonuses.map((bonus, index) => <article key={bonus.number} className={`flex h-full flex-col overflow-hidden rounded-xl border border-white/10 bg-navy-700 ${index === bonuses.length - 1 ? 'md:col-span-2 md:mx-auto md:max-w-xl' : ''}`} data-id="element-25" data-mp="1m85l9ku25ojq" data-mpi={index}>
              <img src={bonus.image} alt={`${bonus.title} bonus product mockup`} className="h-48 w-full object-cover sm:h-56" loading="lazy" data-id="element-26" data-mp="3r6i6sysydh9j" />
              <div className="flex flex-1 flex-col p-6" data-id="element-27" data-mp="2zesjon8q64zd">
                <div className="flex items-center gap-3" data-id="element-28" data-mp="2zhf0zelf3yus">
                  <span className="rounded-md bg-gold px-2.5 py-1 text-[11px] font-black uppercase tracking-wide text-navy-900" data-id="element-29" data-mp="2uhsnr55lailz">
                    Bonus {bonus.number}
                  </span>
                  <span className="text-sm text-white/40 line-through" data-id="element-30" data-mp="33g4er8adbiey">
                    {bonus.price}
                  </span>
                  <span className="text-sm font-black uppercase text-grass" data-id="element-31" data-mp="ns4bcc0sucav">
                    Free
                  </span>
                </div>
                <h3 className="mt-4 font-display text-lg font-extrabold text-white" data-id="element-32" data-mp="3cjg1plcc55n5">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-33" data-mp="3hgg7rw96q8e9">
                  {bonus.description}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}